// extracted by mini-css-extract-plugin
export default {"box":"lesnropr24JrMl7wHF64","formBox":"uXk3rYMwbIPbbqkA1ctF"};